import { StripePaymentRequestButtonElementOptions } from '@stripe/stripe-js';
import { getParameterFromURL } from '../../../../utils/scripts';

const subscrUK = getParameterFromURL('subscrUK') === 'true';
const subscrEU = getParameterFromURL('subscrEU') === 'true';

const country = subscrUK ? 'GB' : subscrEU ? 'DE' : 'US';
const currency = subscrUK ? 'gbp' : subscrEU ? 'eur' : 'usd';

export const options = (paymentRequest: any): StripePaymentRequestButtonElementOptions => ({
  paymentRequest,
  style: {
    paymentRequestButton: {
      height: '50px',
    },
  },
});

export const paymentRequestOptions = (label: string, amount: number) => ({
  country,
  currency,
  total: {
    label,
    amount,
  },
  requestPayerName: true,
  requestPayerEmail: true,
});
